import React, { ReactElement } from "react";

function ButtonBasic(
  props: Readonly<{
    children: ReactElement | string;
    onClick: any;
    className?: string;
  }>
) {
  return (
    <button
      className={
        "px-6 py-[2px] rounded-md bg-lightbg-headerPrimary shadow-md transition duration-200 hover:bg-lightbg-headerSecondary hover:scale-105 whitespace-nowrap " +
        (props.className || "")
      }
      onClick={props.onClick}
    >
      {props.children}
    </button>
  );
}

export default ButtonBasic;
